import axios from '@/services/ProductService/productInstance'

const CreateSection = async (section, imgUrl) => {
  return new Promise((resolve, reject) => {
    axios.post('/sections/', { ...section, thumbnail_image_url: imgUrl })
      .then((response) => {
          resolve(response?.data?.id)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export default CreateSection
